import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrReviewTag.ts
var t = () => e("reviewTag");
//#endregion
export { t as useTrReviewTag };
